import { EnumUserRole } from "@mtb/mtb-requests";

export const tenantRolePermissions = [
  EnumUserRole.ADMIN,
  EnumUserRole.TENANTADMIN,
  EnumUserRole.TENANTCONTRIBUTOR,
  EnumUserRole.OWNER,
];

/** Team page / tourguide invite — TADMIN + ADMIN only (OWNER excluded). */
export const teamRolePermissions = [
  EnumUserRole.ADMIN,
  EnumUserRole.TENANTADMIN,
];

export const adminAppRolePermissions = [
  EnumUserRole.ADMIN,
  EnumUserRole.TENANTADMIN,
  EnumUserRole.TENANTCONTRIBUTOR,
  EnumUserRole.OWNER,
  EnumUserRole.GUEST,
];
